/**
 * Component registry — maps `field.component` string → React component.
 * Imported by BookingFormShell to render registry-listed fields.
 */
import TextField     from "./TextField";
import NumberField   from "./NumberField";
import TextareaField from "./TextareaField";
import CheckboxPill  from "./CheckboxPill";
import ChipsField    from "./ChipsField";

export const COMPONENTS = {
  TextField,
  NumberField,
  TextareaField,
  CheckboxPill,
  ChipsField,
};
